import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';  

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';


import 'bootstrap-icons/font/bootstrap-icons.css';

import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'



createApp(App)

.use(store)
.use(router)
.component('Multiselect', Multiselect)
.mount('#app')
